(function () {
  const unavailableText = 'SOLD OUT';
  const productVariantIds = new Set(
    (window.RP_NOT_CURRENTLY_AVAILABLE_VARIANT_IDS || []).map(String)
  );
  const purchaseSelector = [
    'form[action*="/cart/add"] button[type="submit"]',
    'form[action*="/cart/add"] input[type="submit"]',
    '[data-js-product-add-to-cart]',
    '[data-js-atc]',
    '.shopify-payment-button',
    'shopify-buy-it-now-button',
    'shopify-accelerated-checkout',
    '.shg-product-atc-btn',
    '.shogun-add-to-cart-button',
    '.rp-pack-anchor-top'
  ].join(',');

  function isCurrentProductForm(form) {
    const variantInput = form.querySelector('input[name="id"]');
    return variantInput && productVariantIds.has(String(variantInput.value));
  }

  function isCurrentProductControl(control) {
    const form = control.closest('form[action*="/cart/add"]');

    if (form) return isCurrentProductForm(form);

    return control.matches(
      '[data-js-atc], .shg-product-atc-btn, .shogun-add-to-cart-button, .rp-pack-anchor-top'
    );
  }

  function setButtonText(control) {
    if (control.matches('input[type="submit"]')) {
      if (control.value !== unavailableText) control.value = unavailableText;
      return;
    }

    const textElement = control.querySelector(
      '[data-js-product-add-to-cart-text], .button__text'
    );

    if (textElement) {
      if (textElement.textContent.trim() !== unavailableText) {
        textElement.textContent = unavailableText;
      }
      return;
    }

    if (
      control.matches('button, a') &&
      control.textContent.trim() !== unavailableText
    ) {
      control.textContent = unavailableText;
    }
  }

  function disablePurchaseControls(root) {
    const controls = [];

    if (root instanceof Element && root.matches(purchaseSelector)) {
      controls.push(root);
    }

    if (root.querySelectorAll) {
      controls.push(...root.querySelectorAll(purchaseSelector));
    }

    controls.filter(isCurrentProductControl).forEach((control) => {
      control.classList.add('rp-not-currently-available');
      control.setAttribute('aria-disabled', 'true');

      if ('disabled' in control) control.disabled = true;
      if (control.matches('a')) control.setAttribute('tabindex', '-1');

      setButtonText(control);
    });
  }

  function blockPurchase(event) {
    const target = event.target instanceof Element
      ? event.target.closest(purchaseSelector)
      : null;

    if (!target || !isCurrentProductControl(target)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function blockProductForm(event) {
    if (
      !event.target.matches('form[action*="/cart/add"]') ||
      !isCurrentProductForm(event.target)
    ) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  function initialize() {
    disablePurchaseControls(document);

    document.addEventListener('click', blockPurchase, true);
    document.addEventListener('submit', blockProductForm, true);
    document.addEventListener('VARIANT_CHANGE', function () {
      window.requestAnimationFrame(function () {
        disablePurchaseControls(document);
      });
    });

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node instanceof Element) disablePurchaseControls(node);
          });

          if (mutation.target instanceof Element) {
            const control = mutation.target.closest(purchaseSelector);
            if (control) disablePurchaseControls(control);
          }
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
